import { useState } from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { InvoiceListPanel } from '../components/invoicing/InvoiceListPanel';
import { PennylaneInvoicePreviewPanel } from '../components/admin/PennylaneInvoicePreviewPanel';
import { ChannelMappingPanel } from '../components/invoicing/ChannelMappingPanel';
import { VatConfigPanel } from '../components/invoicing/VatConfigPanel';
import { InvoiceGeneratePanel } from '../components/invoicing/InvoiceGeneratePanel';
import { InvoiceStatusPanel } from '../components/invoicing/InvoiceStatusPanel';
import { InvoiceViewPanel } from '../components/invoicing/InvoiceViewPanel';
import { RedatePanel } from '../components/invoicing/RedatePanel';
import { AutoFinalizePanel } from '../components/invoicing/AutoFinalizePanel';

const ENTITIES = [
  { id: 'bi_immo', label: 'Bonjour Immobilier' },
  { id: 'afpv', label: 'AFPV Invest' },
];

export function InvoicingPage() {
  const [entityId, setEntityId] = useState('bi_immo');

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">FR Invoicing</h1>
            <p className="text-sm text-muted-foreground mt-1">
              Generate and manage Pennylane draft invoices for FR entities.
            </p>
          </div>
          <div>
            <label className="text-sm font-medium text-muted-foreground block mb-1">Entity</label>
            <select
              value={entityId}
              onChange={(e) => setEntityId(e.target.value)}
              className="h-9 rounded-md border border-input bg-background px-3 text-sm"
            >
              {ENTITIES.map((ent) => (
                <option key={ent.id} value={ent.id}>{ent.label}</option>
              ))}
            </select>
          </div>
        </div>

        <Tabs defaultValue="invoices">
          <TabsList>
            <TabsTrigger value="invoices">Invoice List</TabsTrigger>
            <TabsTrigger value="control">Control Panel</TabsTrigger>
          </TabsList>

          <TabsContent value="invoices">
            <div className="space-y-6 pt-2">
              <InvoiceListPanel entityId={entityId} />
            </div>
          </TabsContent>

          <TabsContent value="control">
            <div className="space-y-6 pt-2">
              {/* Section B: Channel mapping + VAT config (prerequisites) */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <ChannelMappingPanel entityId={entityId} />
                <VatConfigPanel entityId={entityId} />
              </div>

              {/* Section A: Invoice Preview */}
              <PennylaneInvoicePreviewPanel entityId={entityId} />

              {/* Section C: Generate Drafts */}
              <InvoiceGeneratePanel entityId={entityId} />

              {/* Section D: Invoice Status List */}
              <InvoiceStatusPanel entityId={entityId} />

              {/* Section E: View Live Invoice */}
              <InvoiceViewPanel entityId={entityId} />

              {/* Section F: Re-date Drafts */}
              <RedatePanel />

              {/* Section G: Auto-Finalize Pipeline */}
              <AutoFinalizePanel entityId={entityId} />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
}
